import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  // Icon name
  name: string;
  small?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialIcon',
  props: {
    name: null,
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  // Icon name
  name: string;
  small?: boolean;
};

// ========== PROPS ==========


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["material-symbols-sharp", { 'small-size': props.small }])
  }, _toDisplayString(props.name), 3))
}
}

})